import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, Wallet } from "lucide-react";

export const PagoOnlineTab = () => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <p className="text-sm text-muted-foreground">Configura recebedores para pagos online</p>
      <Button className="gap-2 glow-orange"><Plus className="w-4 h-4" />Nuevo Recebedor</Button>
    </div>
    <Card className="bg-card border-border/50">
      <CardContent className="py-12 text-center">
        <Wallet className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
        <p className="text-muted-foreground">Configurar en Ajustes &gt; Pagos &gt; Online</p>
      </CardContent>
    </Card>
  </div>
);
